export const TestIds = {
  ResponsivePopupPageBg: 'responsivePopupPageBg',
} as const;
